import { useTranslation } from "react-i18next";
import { ArrowLeft2, ArrowRight2 } from "iconsax-react";
import { Button, ButtonGroup } from "@/shared/ui";

export type CalendarViewMode = "day" | "week" | "month";

interface Props {
  viewMode: CalendarViewMode;
  onViewModeChange: (mode: CalendarViewMode) => void;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
  title: string;
}

export default function CalendarHeader({ viewMode, onViewModeChange, onPrev, onNext, onToday, title }: Props) {
  const { t } = useTranslation("Common");

  const viewModeOptions = [
    { label: t("calendar.day"), value: "day" },
    { label: t("calendar.week"), value: "week" },
    { label: t("calendar.month"), value: "month" },
  ];

  return (
    <div className="flex items-center justify-between mb-5">
      <div className="flex items-center gap-2">
        <Button isIconButton variant="secondary" size="sm" onClick={onPrev} className="w-8! h-8! p-0!">
          <ArrowLeft2 size={16} color="currentColor" />
        </Button>
        <Button variant="secondary" size="md" onClick={onToday}>
          {t("calendar.today")}
        </Button>
        <Button isIconButton variant="secondary" size="sm" onClick={onNext} className="w-8! h-8! p-0!">
          <ArrowRight2 size={16} color="currentColor" />
        </Button>
      </div>

      <span className="text-body-bold-lg content-base-primary">{title}</span>

      <ButtonGroup
        options={viewModeOptions}
        value={viewMode}
        onChange={(val) => onViewModeChange(val as CalendarViewMode)}
      />
    </div>
  );
}

